var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1607_8959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9183 7.08173C22.3508 12.5143 24.5528 19.1203 21.8365 21.8365C19.1203 24.5528 12.5143 22.3508 7.08173 16.9183C1.64915 11.4857 -0.552831 4.87974 2.16346 2.16346C4.87974 -0.552831 11.4857 1.64915 16.9183 7.08173Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08173 7.08173C1.64915 12.5143 -0.552831 19.1203 2.16346 21.8365C4.87974 24.5528 11.4857 22.3508 16.9183 16.9183C22.3508 11.4857 24.5528 4.87974 21.8365 2.16346C19.1203 -0.552831 12.5143 1.64915 7.08173 7.08173Z",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1607_8959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.1177fc88ae4a8d84434ba5389c409051.svg";
export { ForwardRef as ReactComponent };